import { Tradable } from "../../interfaces/tradable";
import { IndexAllocation } from "../../tradable/index-allocation";
import { INDEX_TYPE } from "@helpers/constants";
import { TradableDetailInterface, TradableDetailType } from "@models/interfaces/tradable_detail_types";

export class Index extends Tradable {
	protected static readonly currencyType: string = INDEX_TYPE;

	private index_original_fiat_symbol: string = "";
	private index_provider: string = "";

	protected readonly tradable_actions: string[] = ["buy", "sell", "swap", "savings"];

	public readonly tradableDetailLabels: TradableDetailInterface[] = [
		{
			label: "daily_high",
			translationKey: "tradable_detail_label_daily_high",
			type: TradableDetailType.FIAT
		},
		{
			label: "daily_low",
			translationKey: "tradable_detail_label_daily_low",
			type: TradableDetailType.FIAT
		},
		{
			label: "monthly_volatility",
			translationKey: "tradable_detail_label_monthly_volatility",
			type: TradableDetailType.PERCENTAGE
		},
		{
			label: "high_52_w",
			translationKey: "tradable_detail_label_high_52_w",
			type: TradableDetailType.FIAT
		},
		{
			label: "low_52_w",
			translationKey: "tradable_detail_label_low_52_w",
			type: TradableDetailType.FIAT
		}
	];

	protected readonly tradable_detail_fields: string[] = ["change24h_return"];

	public getCurrencyType(): string {
		return Index.currencyType;
	}

	public getIndexOriginalFiatSymbol(): string {
		return this.index_original_fiat_symbol;
	}

	public getIndexProviderName(): string {
		return this.index_provider;
	}

	public getPrecision(): number {
		return 0;
	}

	public getIndexAllocations(): IndexAllocation[] {
		return this.getAssetPrices()?.getIndexAllocations() ?? [new IndexAllocation()];
	}

	// Methods to be reworked

	public isHodlAsset(type: string): boolean {
		return false;
	}

	public isHodlTradable(type: string): boolean {
		return false;
	}

	public isWithdrawActive(): boolean {
		return false;
	}

	public isDepositActive(): boolean {
		return false;
	}

	public isTransferActive(): boolean {
		return false;
	}

	public isIota(): boolean {
		return false;
	}

	public isStellar(): boolean {
		return false;
	}
}
